
import moment from 'moment';
import { TimeZoneUtils } from './timezone.utils';

export class SchedulerUtils{

    public static updateScheduleObject(m) {
        if (m.scheduleArr){

            let scheduleArr = m.scheduleArr as any [];

            m.scheduleArr.forEach( (d: any) => {
                d.start = TimeZoneUtils.timezoneConvert(d.startDate);
                d.end = TimeZoneUtils.timezoneConvert(d.endDate);
            });

            let targetObj = m.scheduleArr.find(schedule => schedule.IsNew);

            if (!targetObj){
                m.scheduleArr.forEach(
                    (d: any) => {
                    d.startHour = new Date(d.start).getHours();
                    d.startMinutes = new Date(d.start).getMinutes();
                    d.endHours = new Date(d.end).getHours();
                    d.endMinutes = new Date(d.end).getMinutes();
                    
                    d.position = parseInt(d.startHour + 1) * 70 + (parseInt(d.startMinutes) / 60) * 70;
                    d.length = parseInt(d.endHours + 1) * 70 + (parseInt(d.endMinutes) / 60) * 70;
                    d.length += (new Date(d.end).getDay() == new Date(d.start).getDay() ? 0 : 1) * 24 * 70;
                    m.doubleDays = d.length > 1748 || m.doubleDays;
                    console.log("int--->" + d.startHour + 'end-->' + d.endHours + 'left' + d.position + 'right' + d.length);
                });

                if (m.MaintanceListArr && m.MaintanceListArr.length > 0){
                    m.MaintanceListArr.forEach(
                        (d: any) => {
                            d.start = TimeZoneUtils.timezoneConvert(d.startDate);
                            d.end = TimeZoneUtils.timezoneConvert(d.endDate);
                            d.startHour = new Date(d.start).getHours();
                            d.startMinutes = new Date(d.start).getMinutes();
                            d.endHours = new Date(d.end).getHours();
                            d.endMinutes = new Date(d.end).getMinutes();
                            d.position = parseInt(d.startHour + 1) * 70 +(parseInt(d.startMinutes) / 60) * 70;
                            d.length = parseInt(d.endHours + 1) * 70 + (parseInt(d.endMinutes) / 60) * 70;
                      }); 
                }
                
            }else{

                const startTime = moment(targetObj.start).startOf('day').toDate();
                const day = new Date(startTime).getDay();

                m.scheduleArr = m.scheduleArr.filter((d: any) => {
                    if (new Date(d.end) < startTime){
                        return false;
                    }

                    if (moment(d.start).startOf('day').toDate() > startTime && new Date(d.start) > new Date(targetObj.end) ){
                        return false;
                    }

                    if (new Date(d.start) < startTime){
                        d.start = startTime;
                    }

                    d.startHour = new Date(d.start).getHours() + (new Date(d.start).getDay() == day ? 0 : 24);
                    d.startMinutes = new Date(d.start).getMinutes();
                    d.endHours = new Date(d.end).getHours() + (new Date(d.end).getDay() == day ? 0 : 24);
                    d.endMinutes = new Date(d.end).getMinutes();
                    
                    d.position = parseInt(d.startHour + 1) * 70 + (parseInt(d.startMinutes) / 60) * 70;
                    d.length = parseInt(d.endHours + 1) * 70 + (parseInt(d.endMinutes) / 60) * 70;
                    m.doubleDays = d.length > 1748 || m.doubleDays;
                    return true;
                });

                if (m.MaintanceListArr && m.MaintanceListArr.length > 0){
                    m.MaintanceListArr = m.MaintanceListArr.filter(
                        (d: any) => {
                            d.start = TimeZoneUtils.timezoneConvert(d.startDate);
                            d.end = TimeZoneUtils.timezoneConvert(d.endDate);

                            if (new Date(d.end) < startTime){
                                return false;
                            }
        
                            if (moment(d.start).startOf('day').toDate() > startTime && new Date(d.start) > new Date(targetObj.end) && !m.doubleDays){
                                return false;
                            }
        
                            if (new Date(d.start) < startTime){
                                d.start = startTime;
                            }

                            d.startHour = new Date(d.start).getHours() + (new Date(d.start).getDay() == day ? 0 : 24);
                            d.startMinutes = new Date(d.start).getMinutes();
                            d.endHours = new Date(d.end).getHours() + (new Date(d.end).getDay() == day ? 0 : 24);
                            d.endMinutes = new Date(d.end).getMinutes();
                            d.position = parseInt(d.startHour + 1) * 70 +(parseInt(d.startMinutes) / 60) * 70;
                            d.length = parseInt(d.endHours + 1) * 70 + (parseInt(d.endMinutes) / 60) * 70;
                            m.doubleDays = d.length > 1748 || m.doubleDays;

                            return true;
                      }); 
                }
            }
        }   
    }




    public static updateMaintenanceObject(m) {

        if (m.MaintenaceAccess){
            m.MaintenaceAccess.forEach(a => {
                if (a.Mlist){

                    let targetObj =  a.Mlist.find(schedule => schedule.IsNew || schedule.isNew);

                    if (!targetObj){
                        a.Mlist.forEach((d:any) =>{
                            d.start = TimeZoneUtils.timezoneConvert(d.startDate);
                            d.end = TimeZoneUtils.timezoneConvert(d.endDate);
                            d.startHour = new Date(d.start).getHours();
                            d.startMinutes = new Date(d.start).getMinutes();
                            d.endHours = new Date(d.end).getHours();
                            d.endMinutes = new Date(d.end).getMinutes();
                            d.position =
                            parseInt(d.startHour + 1) * 70 + (parseInt(d.startMinutes) / 60) * 70;
                            d.length =
                            parseInt(d.endHours + 1) * 70 + (parseInt(d.endMinutes) / 60) * 70;
                            d.length += (new Date(d.end).getDay() == new Date(d.start).getDay() ? 0 : 1) * 24 * 70;
                            m.doubleDays = d.length > 1748 || m.doubleDays
                        });
                    }else{

                        a.Mlist.forEach( d => {
                            d.start = TimeZoneUtils.timezoneConvert(d.startDate);
                            d.end = TimeZoneUtils.timezoneConvert(d.endDate);
                        });

                        const startTime = moment(targetObj.start).startOf('day').toDate();
                        const day = new Date(startTime).getDay();


                        a.Mlist = a.Mlist.filter( d => {
                            if (new Date(d.end) < startTime){
                                return false;
                            }
        
                            if (moment(d.start).startOf('day').toDate() > startTime && new Date(d.start) > new Date(targetObj.end) ){
                                return false;
                            }
        
                            if (new Date(d.start) < startTime){
                                d.start = startTime;
                            }
        
                            d.startHour = new Date(d.start).getHours() + (new Date(d.start).getDay() == day ? 0 : 24);
                            d.startMinutes = new Date(d.start).getMinutes();
                            d.endHours = new Date(d.end).getHours() + (new Date(d.end).getDay() == day ? 0 : 24);
                            d.endMinutes = new Date(d.end).getMinutes();
                            
                            d.position = parseInt(d.startHour + 1) * 70 + (parseInt(d.startMinutes) / 60) * 70;
                            d.length = parseInt(d.endHours + 1) * 70 + (parseInt(d.endMinutes) / 60) * 70;
                            m.doubleDays = d.length > 1748 || m.doubleDays;
                            return true;
                        });
                    }
                }
            });
        }
    }
}